import { motion } from "framer-motion";
import truck from "../../assets/images/msctruck.png";

const MovingTruck = () => {
  const isMobile = window.innerWidth < 768;

  const truckWidth = isMobile ? 300 : 440;
  const truckHeight = isMobile ? 225 : 330;

  // PNG has 43px transparent padding at the bottom
  const bottomPadding = 43;

  return (
    <section
      style={{
        position: "relative",
        overflow: "hidden",
        height: isMobile ? "240px" : "320px",
        background:
          "linear-gradient(180deg,#e2e8f0 0%,#dbeafe 45%,#bfdbfe 100%)",
      }}
    >
      {/* Sun Glow */}
      {!isMobile && (
        <motion.div
          animate={{ opacity: [0.25, 0.4, 0.25] }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          style={{
            position: "absolute",
            inset: 0,
            background:
              "radial-gradient(circle at 70% 25%,rgba(255,255,255,.6),transparent 60%)",
          }}
        />
      )}

      {/* Clouds */}
      <motion.div
        animate={{ x: ["0%", "-12%", "0%"] }}
        transition={{
          duration: isMobile ? 80 : 55,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        style={{
          position: "absolute",
          top: 40,
          left: 0,
          right: 0,
          height: 80,
          background:
            "linear-gradient(90deg,transparent,rgba(255,255,255,.6),transparent)",
          filter: isMobile ? "blur(14px)" : "blur(26px)",
        }}
      />

      {/* Skyline */}
      {!isMobile && (
        <motion.div
          animate={{ x: ["0%", "-4%", "0%"] }}
          transition={{
            duration: 48,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          style={{
            position: "absolute",
            bottom: 95,
            left: 0,
            right: 0,
            height: 95,
            background:
              "linear-gradient(180deg,rgba(30,41,59,.45),rgba(30,41,59,.7))",
            clipPath:
              "polygon(0 70%,5% 55%,10% 65%,15% 45%,20% 60%,25% 40%,30% 60%,35% 50%,40% 65%,45% 45%,50% 60%,55% 50%,60% 65%,65% 45%,70% 60%,75% 50%,80% 65%,85% 45%,90% 60%,95% 50%,100% 65%,100% 100%,0 100%)",
          }}
        />
      )}

      {/* Haze */}
      <motion.div
        animate={{ opacity: [0.12, 0.2, 0.12] }}
        transition={{
          duration: 9,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        style={{
          position: "absolute",
          bottom: 95,
          left: 0,
          right: 0,
          height: 140,
          background:
            "linear-gradient(180deg,transparent,rgba(255,255,255,.4))",
          filter: isMobile ? "blur(10px)" : "blur(24px)",
        }}
      />

      {/* Road */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          height: 95,
          background: "#1f2937",
        }}
      />

      {/* Road Line */}
      <motion.div
        animate={{ x: ["-20%", "120%"] }}
        transition={{
          duration: isMobile ? 3 : 2.2,
          repeat: Infinity,
          ease: "linear",
        }}
        style={{
          position: "absolute",
          bottom: 46,
          width: 160,
          height: 3,
          background:
            "linear-gradient(90deg,transparent,#fff,transparent)",
        }}
      />

      {/* Shadow */}
      <motion.div
        animate={{
          x: ["110%", "-45%"],
          scaleX: [1, 0.97, 1],
        }}
        transition={{
          x: {
            duration: isMobile ? 22 : 18,
            repeat: Infinity,
            ease: "linear",
          },
          scaleX: {
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut",
          },
        }}
        style={{
          position: "absolute",
          bottom: 8,
          width: truckWidth * 0.72,
          height: 18,
          background: "rgba(0,0,0,.45)",
          filter: "blur(15px)",
          borderRadius: "50%",
        }}
      />

      {/* Truck */}
      <motion.img
        src={truck}
        alt="Truck"
        animate={{
          x: ["110%", "-45%"],
          y: [bottomPadding, bottomPadding - 1, bottomPadding],
        }}
        transition={{
          x: {
            duration: isMobile ? 22 : 18,
            repeat: Infinity,
            ease: "linear",
          },
          y: {
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut",
          },
        }}
        style={{
          position: "absolute",
          bottom: 0,
          width: truckWidth,
          height: truckHeight,
          objectFit: "contain",
          background: "transparent",
          filter: "drop-shadow(0 8px 12px rgba(0,0,0,.18))",
          willChange: "transform",
        }}
      />
    </section>
  );
};

export default MovingTruck;